module.exports = __webpack_public_path__ + "img/ic_24_question.bdf017dc.svg";